export default __webpack_public_path__ + "static/media/regulatory--light-rail-divided-highway--g1.db3927c2.png";